module.exports = __webpack_public_path__ + "img/DZ.a33da11f.png";